import Table, { TableHeader } from './Table';

export default Table;
export type { TableHeader };
